'use strict'
const config = {
  api_secret: 'Qfhh852SWmQ5btcg',
  // 管理员应用ID
  admin_app_id: 1,
  // 前端应用ID
  frontend_app_id: 2,
  upload: {
    // 上传图片大小限制，单位字节(Byte)
    image_max_size: 1024 * 1024 * 10,
    //  上传图片后缀
    image_exts: ['.webp', '.jpg', '.jpeg', '.png', '.gif', '.bmp'],
    // 上传图片格式类型
    image_mime_types: ['image/webp', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp'],
    // 上传文件大小限制，单位字节(Byte)
    file_max_size: 1024 * 1024 * 1024 * 3,
    //  上传文件后缀
    file_exts: ['.pdf', '.doc', '.docx', '.ppt', '.pptx', '.zip'],
    // 上传文件格式类型
    file_mime_types: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/x-zip-compressed', 'application/x-compressed', 'application/x-zip-压缩', 'application/x-zip', 'application/zip', 'application/octet-stream', 'multipart/x-zip'],
    // 上传视频大小限制，单位字节(Byte)
    video_max_size: 1024 * 1024 * 1024 * 3,
    // 上传视频后缀
    video_exts: ['.mp4'],
    // 上传音视频格式类型
    video_mime_types: ['video/mp4']
  },
  // 来源媒体
  source_names: [
    {value: '新华网', label: '新华网'},
    {value: '人民日报', label: '人民日报'},
    {value: '中国政府网', label: '中国政府网'},
    {value: '央视网', label: '央视网'}
  ],
  // 来源媒体对应网址
  source_url_list: {
    '新华网': 'https://www.xinhuanet.com/',
    '人民网': 'https://www.people.com.cn/',
    '中国政府网': 'https://www.gov.cn/',
    '央视网': 'https://news.cctv.com/'
  },
  // 样式标签
  tags: ['热门', '推荐', '原创']
}

export {
  config
}
